import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { getFieldText } from "../../scripts/helperScripts";

const FamilyChartModal = ({ familyChart, onCloseClick }) => {
  return (
    <Modal show animation={false}>
      <Modal.Header className="bg-safy-secondary2">
        <Modal.Title>Family Chart Holder</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <b>{familyChart.clientName}</b>
        {familyChart.children.length > 0 ? (
          <div className="d-flex flex-wrap ms-4 my-1">
            <b className="me-2">Child:</b>
            {familyChart.children.map((child) => (
              <Link
                key={child.ccx_careteamid}
                className="mx-2"
                to={`/${
                  child["con.programs"] ? "client" : "contact"
                }/${getFieldText(child.ccx_contact).replace(/[{}]/g, "")}`}
              >
                {child["con.firstlast"]}
              </Link>
            ))}
          </div>
        ) : null}
        {familyChart.other.length > 0 ? (
          <div className="d-flex flex-wrap ms-4">
            <b className="me-2">Other relationship:</b>
            {familyChart.other.map((other) => (
              <Link
                key={other.ccx_careteamid}
                className="mx-2"
                to={`/${
                  other["con.programs"] ? "client" : "contact"
                }/${getFieldText(other.ccx_contact).replace(/[{}]/g, "")}`}
              >
                {other["con.firstlast"]}
              </Link>
            ))}
          </div>
        ) : null}
      </Modal.Body>
      <Modal.Footer className="bg-safy-secondary2">
        <button className="btn btn-primary" onClick={onCloseClick}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default FamilyChartModal;
